import {Component, OnInit} from '@angular/core';
import {Impresa} from "../../../models/impresa.model";
import {RegioneDTO} from "../../../models/regione.model";
import {ConfirmationService, MenuItem, MessageService, SelectItem} from "primeng/api";
import {DialogService} from "primeng/dynamicdialog";
import {MagazzinoService} from "../../../services/magazzino.service";
import {ImpreseService} from "../../../services/imprese.service";
import {MagazzinoApiDescriptor, ModelloDispositivoApiDescriptor, MovimentazioneApiBuilder, MovimentazioneApiDescriptor, ScuolaPraticaApiDescriptor, StatoDiscrepanza, TipoMovimentazione} from "../../../models/magazzino.model";
import {MovimentazioneTransferDialogComponent} from "./movimentazione-transfer-dialog/movimentazione-transfer-dialog.component";
import {MovimentazioneEditCreateDialogComponent} from "./movimentazione-edit-create-dialog/movimentazione-edit-create-dialog.component";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";
import {dateAsDDMMYYYY, dateAsYYYYMMDD, dateFromYYYYMMDDsep, datetimeAsHHMMSS, downloadXlsxWorkbook, exportDataToXlsx, getMagazzinoUserSummary, MagazzinoUserSummary} from "../../../lib/support";
import {InconsistencyResolution, InconsistencyResolutionDialogComponent} from "./inconsistency-resolution-dialog/inconsistency-resolution-dialog.component";
import {environment} from "../../../../environments/environment";
import {MovimentazioneAnnullamentoDialogComponent} from "./movimentazione-annullamento-dialog/movimentazione-annullamento-dialog.component";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {PraticaFlowdy2_Firestore} from "../../../models/praticaFirestore.model";
import {DialogComunicaEsitoAppuntamentoFase2} from "../../pratiche/flowdy2/shared/esito-appuntamento-fase2/esito_appuntamento_fase2.component";
import {MovimentazioniCaricamentoDialogComponent} from "./movimentazioni-caricamento-dialog/movimentazioni-caricamento-dialog.component";

@Component({
	selector: 'app-stato-movimentazioni',
	templateUrl: './stato-movimentazioni.component.html',
	styleUrls: ['./stato-movimentazioni.component.scss'],
	providers: [DialogService, ConfirmationService],
})
export class StatoMovimentazioniComponent implements OnInit
{
	protected readonly TipoMovimentazione = TipoMovimentazione;
	protected readonly StatoDiscrepanza = StatoDiscrepanza;
	protected readonly environment = environment;

	lockAzienda: Impresa;
	aziendaLockParam: number;

	uiReady: boolean;
	dataReady: boolean;


	listingImprese: Impresa[];
	listingRegioni: RegioneDTO[];
	listingMagazzini: MagazzinoApiDescriptor[];
	listingMateriali: ModelloDispositivoApiDescriptor[];
	listingScuolePratiche: ScuolaPraticaApiDescriptor[];
	scuoleByPratica: {[key: string]: ScuolaPraticaApiDescriptor};

	compoMovimentazioni: CompoMovimentazione[];
	filteredMovimentazioni: CompoMovimentazione[];
	idAnnullati: string[];

	optionsTypeCreateNew: SelectItem<TipoMovimentazione>[];
	currentTypeCreateNew: TipoMovimentazione;

	// using for debug/superuser
	optionsAzienda: SelectItem<Impresa>[];
	filterAzienda: Impresa;

	optionsTypeFilter: SelectItem<TipoMovimentazione>[];
	filterType: TipoMovimentazione;

	typeDescriptions = {
		"TIM_IMPRESA": "TIM ➔ Impresa",
		"MAGAZZINO_MAGAZZINO": "Magazzino ➔ Magazzino",
		"IMPRESA_INSTALLAZIONE": "Installazione",
		"ALLINEAMENTO_IMPRESA": "Allineamento Impresa",
		"ALLINEAMENTO_TIM": "Allineamento TIM",
		"IMPRESA_TIM": "Impresa ➔ TIM",
		"INSTALLAZIONE_RIENTRO": "Rientro Installazione"
	}


	optionsStatoFaseSpedizione: SelectItem<StatoFaseSpedizione>[] = [
		{ label: "tutti", value: null },
		{ label: "in transito", value: StatoFaseSpedizione.TRANSITO },
		{ label: "consegnata", value: StatoFaseSpedizione.CONSEGNATO },
		// { label: "in attesa", value: StatoFaseSpedizione.ATTESA_SPEDIZIONE }
	];
	filterStatoFaseSpedizione: StatoFaseSpedizione;

	userSummary: MagazzinoUserSummary;

	filterDatesRange: Date[];
	minDate: Date;
	maxDate: Date;

	COLORS_MOVTYPE = {
		"TIM_IMPRESA": "#904794",
		"MAGAZZINO_MAGAZZINO": "#d97f0b",
		"IMPRESA_INSTALLAZIONE": "#258528",
		"ALLINEAMENTO_IMPRESA": "#3173d5",
		"ALLINEAMENTO_TIM": "#a92929",
		"IMPRESA_TIM": "#904794",
		"INSTALLAZIONE_RIENTRO": "#3b9f3e"
	}

	constructor(
		private firestore: AngularFirestore,
		private confirmationService: ConfirmationService,
		private messageService: MessageService,
		public dialogService: DialogService,
		private backendMagazzino: MagazzinoService,
		private impreseService: ImpreseService,
		private route: ActivatedRoute,
		private router: Router
	) {

		this.route.params.subscribe((values) => {
			console.log("changed params to ", values);
			this.reinit();
		})
	}

	reinit() {
		this.userSummary = getMagazzinoUserSummary();

		const canSeeAll = this.userSummary.isSmartFiber || this.userSummary.isPresidio || this.userSummary.isAdmin;
		this.aziendaLockParam = canSeeAll ? (this.route.snapshot.params["aziendaid"] ?? null) : this.userSummary.idImpresa;
		// console.log(this.aziendaLockParam, canSeeAll);

		this.listingRegioni = [];
		this.listingImprese = [];
		this.listingMagazzini = [];
		this.listingMateriali = [];

		this.compoMovimentazioni = [];
		this.filteredMovimentazioni = [];

		// TODO: filter according to user
		this.currentTypeCreateNew = null;
		this.optionsTypeCreateNew = [];
		this.lockAzienda = null;
		this.optionsAzienda = [];
		this.optionsTypeFilter = [];

		this.filterType = null;
		this.filterStatoFaseSpedizione = null;
		this.filterAzienda = null;

		this.filterDatesRange = null;
		this.minDate = null;
		this.maxDate = null;

		this.loadData();
	}

	setUserReferenceFirm () {


		if (this.aziendaLockParam) {

			this.lockAzienda = this.listingImprese.find((item) => { return item.id == this.aziendaLockParam });
			this.filterAzienda = this.lockAzienda;
		}

		this.rebuildCreateCategories();

	}

	ngOnInit() {
		this.uiReady = true;
	}

	getMovimentazioniAnnullate () {
		const annullate = this.compoMovimentazioni.filter((item) => {
			return item.discrepanza?.stato == "CONFERMATO_ANNULLAMENTO" ?? false;
		}).map((item) => { return item.id; });
		const correttivi_annullate = this.compoMovimentazioni.filter((item) => {
			return annullate.indexOf(item.correttivo_per) != -1
		}).map((item) => { return item.id; });

		return [...annullate, ...correttivi_annullate];
	}

	loadData () {

		let impreseById: {[key: string]: Impresa} = {};
		let regioniById = {};
		let materialiById: {[key: string]: ModelloDispositivoApiDescriptor} = {};
		let magazziniById: {[key: string]: MagazzinoApiDescriptor} = {};
		let movimentazioniRaw: MovimentazioneApiDescriptor[] = [];
		let scuoleRaw: ScuolaPraticaApiDescriptor[] = [];

		const loaded = {
			magazzini:			false,
			imprese:			false,
			regioni:			false,
			materiali:			false,
			movimentazioni:		false,
			scuole:				false
		}

		const checkUpdateState = () => {
			if (Object.values(loaded).every((value) => value)) {

				this.setUserReferenceFirm();

				const daymillis = 1000 * 3600 * 24;
				this.compoMovimentazioni = movimentazioniRaw.map((item) => {
					// console.log("working on src: ", item);
					const magazzinoFrom: MagazzinoApiDescriptor = item.origine ? magazziniById[item.origine] : null;
					const magazzinoTo: MagazzinoApiDescriptor = item.destinazione ? magazziniById[item.destinazione] : null;
					const aziendaFrom = magazzinoFrom ? impreseById[magazzinoFrom.azienda] : null;
					const aziendaTo = magazzinoTo ? impreseById[magazzinoTo.azienda] : null;

					const handlingFor = this.lockAzienda ?? impreseById[environment.magazzino.aziendaid_TIM];

					const lockerIsSender = aziendaFrom != null && handlingFor.id == aziendaFrom.id;
					const lockerIsReceiver = aziendaTo != null && handlingFor.id == aziendaTo.id;

					const data_spedito = item.spedito ? dateFromYYYYMMDDsep(item.spedito) : null
					let consegna_scaduta = false;
					if (item.consegnato == null && data_spedito != null) {
						const now = new Date().getTime();
						const time_sent = data_spedito.getTime();
						consegna_scaduta = ((now - time_sent) / (86400000)) > environment.magazzino.movexpire_days;
					}



					return {
						id:				item.id,
						tipo:			item.tipo,
						pratica:		item.pratica,
						stato_pratica:	item.stato_pratica,
						materiali:		item.materiali.map((sub) => {
							return {
								id: 	sub.id,
								info:	materialiById[sub.id],
								qt:		sub.qt
							}
						}),
						spedito:		item.spedito,
						consegnato:		item.consegnato,
						mittente: 		aziendaFrom,
						destinatario: 		aziendaTo,
						origine: 		magazzinoFrom,
						destinazione: 	magazzinoTo,
						dataSpedito: data_spedito,
						dataConsegnato: item.consegnato ? dateFromYYYYMMDDsep(item.consegnato) : null,
						discrepanza: item.discrepanza,
						note:			(item.note != null && item.note.trim().length > 0) ? item.note : null,
						correttivo_per: item.correttivo_per,
						allowConfirmDelivery: item.spedito != null && item.consegnato == null && (
							lockerIsReceiver || (item.destinazione == null && lockerIsSender)
						),
						allowFixInconsistency: this.lockAzienda == null  || (lockerIsReceiver && lockerIsSender),
						consegna_scaduta: consegna_scaduta,
						allowFillInstallationForm: item.tipo == TipoMovimentazione.IMPRESA_INSTALLAZIONE && item.consegnato == null && item.pratica != null && item.stato_pratica == 31 && lockerIsSender
					}
				});

				this.idAnnullati = this.getMovimentazioniAnnullate();

				const allDates = [
					...this.compoMovimentazioni.map((item) => item.dataConsegnato).filter((item) => item != null),
					...this.compoMovimentazioni.map((item) => item.dataSpedito).filter((item) => item != null)
				];
				allDates.sort((dateA: Date, dateB: Date) => {
					return dateA.getTime() - dateB.getTime()
				});
				this.minDate = allDates[0];
				this.maxDate = allDates[allDates.length - 1];
				this.filterDatesRange = [this.minDate, this.maxDate]

				// console.log(this.compoMovimentazioni);
				this.updateFiltered();

				this.dataReady = true;


			}
		}

		this.backendMagazzino.scuoleListing(this.aziendaLockParam).subscribe((result) => {
			this.listingScuolePratiche = result.listing;
			this.scuoleByPratica = Object.fromEntries(result.listing.map((item) => {
				return [item.pratica.id, item]
			}))
			// console.log("listing scuole pratiche ", this.listingScuolePratiche);
			loaded.scuole = true;
			checkUpdateState();
		});

		this.impreseService.get().subscribe((result: Impresa[]) => {
			this.listingImprese = result;
			impreseById = {};
			for (let item of result) {
				impreseById[`${item.id}`] = item;
			}
			loaded.imprese = true;
			this.optionsAzienda = [{
				label: "tutte le imprese",
				value: null
			}, ...this.listingImprese.map((item) => {
				return {
					label: item.ragioneSociale,
					value: item
				}
			})];
			checkUpdateState();
		});

		this.backendMagazzino.regioneList().subscribe((result) => {
			this.listingRegioni = result.listing;
			regioniById = {};
			for (let item of result.listing) {
				regioniById[`${item.id}`] = item;
			}
			loaded.regioni = true;
			checkUpdateState();
		});

		this.backendMagazzino.magazzinoList().subscribe((result) => {
			this.listingMagazzini = result.listing;
			magazziniById = {};
			for (let item of result.listing) {
				magazziniById[`${item.id}`] = item;
			}
			loaded.magazzini = true;
			checkUpdateState();
		});

		this.backendMagazzino.modelloDispositivoList().subscribe((result) => {
			this.listingMateriali = result.listing;
			materialiById = {};
			for (let item of result.listing) {
				materialiById[`${item.id}`] = item;
			}
			loaded.materiali = true;
			checkUpdateState();
		});

		this.backendMagazzino.movimentazioneList(this.aziendaLockParam ?? null).subscribe((result) => {
			console.log("results ", result.listing)
			movimentazioniRaw = result.listing;
			loaded.movimentazioni = true;
			checkUpdateState();
		});
	}

	isInState (mov: CompoMovimentazione, state: StatoFaseSpedizione) {
		if (state == StatoFaseSpedizione.TRANSITO) {
			return ((mov.spedito || mov.tipo == TipoMovimentazione.ALLINEAMENTO_TIM || mov.tipo == TipoMovimentazione.ALLINEAMENTO_IMPRESA) && (mov.destinazione != null || mov.tipo == TipoMovimentazione.IMPRESA_INSTALLAZIONE.valueOf()) && mov.consegnato == null);
		} else if (state == StatoFaseSpedizione.ATTESA_SPEDIZIONE) {
			return ((mov.spedito == null && (mov.tipo != TipoMovimentazione.ALLINEAMENTO_TIM && mov.tipo != TipoMovimentazione.ALLINEAMENTO_IMPRESA)));
		} else if (state == StatoFaseSpedizione.CONSEGNATO) {
			return (mov.consegnato != null);
		}
		return true;
	}



	updateFiltered () {
		// console.log("update date filter");
		const hasDateFrom = !!this.filterDatesRange?.[0];
		const hasDateTo = !!this.filterDatesRange?.[1];

		const isDateInRange = ((dateval: Date) => {
			return ((!hasDateFrom) || (dateval != null && dateval >= this.filterDatesRange[0])) &&
				((!hasDateTo) || (dateval != null && dateval <= this.filterDatesRange[1]));
		});


		this.filteredMovimentazioni = this.compoMovimentazioni.filter((item) => {
			return (
				(this.filterStatoFaseSpedizione == null || this.isInState(item, this.filterStatoFaseSpedizione)) &&
				(this.filterAzienda == null || (item.mittente == this.filterAzienda || item.destinatario == this.filterAzienda)) &&
				(this.filterType == null || this.filterType.valueOf() == item.tipo) &&
				(isDateInRange(item.dataSpedito) || isDateInRange(item.dataConsegnato)) &&
				(this.idAnnullati.indexOf(item.id) == -1)
			);
		});

	}

	// actions handling

	openMovimentazioneTransferDialog (compo: CompoMovimentazione, delivery: boolean) {

		const fase = delivery ? "consegna" : "invio";
		// no allineamenti perché sono "automatici"
		let header: string;
		if (compo.tipo == TipoMovimentazione.IMPRESA_INSTALLAZIONE) {
			// TODO: USE SCHOOL DATA
			header = `Imposta ${fase} per la spedizione ${compo.id} di ${compo.mittente.ragioneSociale}`;
		} else if (compo.tipo == TipoMovimentazione.IMPRESA_TIM) {
			header =`Imposta ${fase} per la spedizione ${compo.id} da ${compo.mittente.ragioneSociale} a TIM`;
		} else if (compo.tipo == TipoMovimentazione.MAGAZZINO_MAGAZZINO) {
			header = `Imposta ${fase} per la spedizione ${compo.id} da ${compo.mittente.ragioneSociale} a ${compo.destinatario.ragioneSociale}`;
		} else if (compo.tipo == TipoMovimentazione.TIM_IMPRESA) {
			header = `Imposta ${fase} per la spedizione ${compo.id} da TIM a ${compo.destinatario.ragioneSociale}`;
		} else {
			throw "tipo di movimentazione non previsto per questo form";
		}

		const ref = this.dialogService.open(MovimentazioneTransferDialogComponent,
			{
				header: header,
				modal: true,
				closable: false,
				width: "70vw",
				data: {
					src: compo,
					materiali: this.listingMateriali,
					direction_delivery: delivery
				}
			}
		);

		ref.onClose.subscribe((result) => {
			if (result != null) {
				console.log("sending ", result);
				this.backendMagazzino.movimentazioneSetTransfer(compo.id, delivery, result).subscribe((data) => {
					const fase = delivery ? "Consegna" : "Spedizione";
					this.messageService.add({
						severity: "success",
						detail: `${fase} impostata con successo.`
					});
					this.loadData();
				});
			}
		});
	}

	getItemEditCreateDialog (compo?: CompoMovimentazione, movtype?: TipoMovimentazione) {

		return this.dialogService.open(MovimentazioneEditCreateDialogComponent,
			{
				header: !!compo ? `Modifica movimentazione` : "Crea movimentazione",
				modal: true,
				closable: false,
				width: "75vw",
				data: {
					src: compo ?? null,
					reqfirm: this.lockAzienda ?? this.listingImprese.find((item) => { return item.id == environment.magazzino.aziendaid_TIM}),
					movtype: movtype ?? compo.tipo,
					magazzini: this.listingMagazzini,
					imprese: this.listingImprese,
					regioni: this.listingRegioni,
					materiali: this.listingMateriali,
					scuole: this.listingScuolePratiche.filter((item) => {
						// in creazione solo pratiche con appuntamento
						return item.pratica.stato_ff2 == 31;
					})
				}
			}
		);

	}

	requestItemCreate (item: MovimentazioneApiBuilder, auto_add_transfer: boolean = true) {
		console.log("richiesta movimentazione: ", item);
		this.backendMagazzino.movimentazioneCreate(item, auto_add_transfer).subscribe({
			next: (response) => {
				this.messageService.add({
					severity: "success",
					detail: `Movimentazione creata con successo.`
				})
				this.loadData();
			},
			error: (error: HttpErrorResponse) => {
				const messages = {
					"empty_materials_list": "lista materiali vuota",
					"send_to_same": "origine e destinazione coincidono",
					"unavailable_materials": "materiali non disponibili"
				};
				const issues: string[] = error.error["issues"].map((issue_code: string) => {
					return messages[issue_code] ?? issue_code
				});


				if (error.status == 422) {
					this.messageService.add({
						severity: "error",
						detail: `Non è stato possibile creare la movimentazione: ${issues.join(", ")}.`
					})
				} else {
					this.messageService.add({
						severity: "error",
						detail: `Non è stato possibile creare la movimentazione: ${error.message}`
					})
				}

			}
		});
	}

	requestItemUpdate (itemid: string, item: MovimentazioneApiDescriptor) {
		// this.backendMagazzino.magazzinoUpdate(itemid, item).subscribe((result) => {
		// 	this.messageService.add({
		// 		severity: "success",
		// 		detail: `Magazzino ${result.item.codice} modificato con successo.`
		// 	});
		// 	this.loadData();
		// });
	}

	openItemCreateDialog (movtype: TipoMovimentazione) {

		const ref = this.getItemEditCreateDialog(null, movtype);
		ref.onClose.subscribe((builder: MovimentazioneApiBuilder) => {
			if (builder != null) {
				console.log("creating movimentazione: ", builder);
				this.requestItemCreate(builder, true);
			}
		});

	}

	openItemEditDialog (compo?: CompoMovimentazione, readonly: boolean = true) {

		const ref = this.getItemEditCreateDialog(compo);

		ref.onClose.subscribe((edited: MagazzinoApiDescriptor) => {
			if (edited != null) {
				// TODO: placeholder
			}
		});
	}

	requestItemDelete (itemid: string) {
		console.warn("PLACEHOLDER - TBA");
		// this.backendMagazzino.movimentazioneDelete(itemid).subscribe((result) => {
		// 	this.messageService.add({
		// 		severity: "success",
		// 		detail: `Magazzino ${result.item.codice} eliminato con successo.`
		// 	});
		// 	this.loadData();
		// });
	}

	openItemDeleteDialog (compo: CompoMovimentazione){

		this.confirmationService.confirm({
			// closable: false,
			header: `Conferma eliminazione movimentazione`,
			message: `Vuoi davvero eliminare questa movimentazione?<br>Questa azione non può essere recuperata.`,
			rejectIcon: 'pi pi-times',
			rejectLabel: "Annulla",
			acceptIcon: 'pi pi-check',
			acceptLabel: 'Conferma',
			accept: () => {
				this.requestItemDelete(compo.id);
			},
			reject: () => {
				// do nothing
			}
		});
	}

	rebuildCreateCategories () {

		let allowedSee = [];
		let allowedCreate = [];
		if (this.lockAzienda == null) {
			// TIM o OPERATORE

			allowedSee = [
				TipoMovimentazione.ALLINEAMENTO_TIM,
				TipoMovimentazione.TIM_IMPRESA,
				TipoMovimentazione.MAGAZZINO_MAGAZZINO,
				TipoMovimentazione.IMPRESA_TIM,
				TipoMovimentazione.IMPRESA_INSTALLAZIONE,
				TipoMovimentazione.ALLINEAMENTO_IMPRESA
			]
			allowedCreate = [
				TipoMovimentazione.ALLINEAMENTO_TIM,
				TipoMovimentazione.TIM_IMPRESA,
				TipoMovimentazione.MAGAZZINO_MAGAZZINO
			];
		} else {
			// AZIENDA
			allowedCreate = [
				TipoMovimentazione.ALLINEAMENTO_IMPRESA,
				TipoMovimentazione.MAGAZZINO_MAGAZZINO,
				TipoMovimentazione.IMPRESA_TIM,
				TipoMovimentazione.IMPRESA_INSTALLAZIONE
			]
			allowedSee = [...allowedCreate];

		}

		this.optionsTypeFilter = allowedSee.map((item) => {
			return {
				label: this.typeDescriptions[item],
				value: item
			}
		});

		this.optionsTypeCreateNew = allowedCreate.map((item) => {
			return {
				label: this.typeDescriptions[item],
				value: item
			}
		})


	}

	openInconsistencyHandling (compo: CompoMovimentazione) {
		console.log("handle inconsistency for ", compo);
		const dialog = this.dialogService.open(InconsistencyResolutionDialogComponent,
		{
			header: "Gestione discrepanza",
			modal: true,
			closable: false,
			width: "75vw",
			data: {
				src: compo,
				magazzini: this.listingMagazzini,
				imprese: this.listingImprese,
				regioni: this.listingRegioni,
				materiali: this.listingMateriali,
				scuole: this.listingScuolePratiche
			}
		});

		dialog.onClose.subscribe((result: InconsistencyResolution) => {
			// console.log("fix result ", result);
			if (result != null) {
				const res_state = result.state;
				let res_counter: MovimentazioneApiBuilder = null;
				if (res_state == StatoDiscrepanza.RISOLTA) {
					res_counter = {
						tipo:	compo.tipo,
						pratica:	compo.pratica,
						origine:		compo.origine.id,
						destinazione:	compo.destinazione?.id ?? null,
						data_richiesta: dateAsYYYYMMDD(new Date(), "-"),
						materiali: Object.fromEntries(result.materials.map((item) => {
							return [item.id, -item.qt]
						}))
					};
				}
				// console.log("fix with", res_state, res_counter);
				this.backendMagazzino.discrepanzaResolve(compo.discrepanza.id, res_state, res_counter).subscribe({next: (data) => {
					this.messageService.add({
						severity: "success",
						detail: `Discrepanza gestita con successo.`
					});
					// console.log("solved with ", data);
					this.loadData();
				}, error: (response: HttpErrorResponse) => {
					this.messageService.add({
						severity: "error",
						detail: `Gestione discrepanza fallita: errore ${response.status}.`
					});
				}});

			}
		})
	}

	handleOutOfTime (compo: CompoMovimentazione) {

		let header = "Annullamento spedizione fuori tempo";
		if (compo.tipo == TipoMovimentazione.IMPRESA_INSTALLAZIONE) {
			const cui = this.scuoleByPratica[compo.pratica].pratica.cui
			header = `Annullamento spedizione fuori tempo di ${compo.mittente.ragioneSociale} per installazione ${cui}`;
		} else if (compo.tipo == TipoMovimentazione.IMPRESA_TIM) {
			header =`Annullamento spedizione fuori tempo da ${compo.mittente.ragioneSociale} a TIM`;
		} else if (compo.tipo == TipoMovimentazione.MAGAZZINO_MAGAZZINO) {
			header = `Annullamento spedizione fuori tempo da ${compo.mittente.ragioneSociale} a ${compo.destinatario.ragioneSociale}`;
		} else if (compo.tipo == TipoMovimentazione.TIM_IMPRESA) {
			header = `Annullamento spedizione fuori tempo da TIM a ${compo.destinatario.ragioneSociale}`;
		}


		// console.log("handing out of time state for item ", item);
		const dialog = this.dialogService.open(MovimentazioneAnnullamentoDialogComponent, {
			header: header,
			modal: true,
			closable: true,
			width: "75vw",
			data: {
				scuole: this.scuoleByPratica,
				movimentazione: compo
			}
		});

		dialog.onClose.subscribe((result) => {
			if (result.requestRevertMov) {
				console.log("reverting ", compo.id, compo);
				this.backendMagazzino.movimentazioneRevert(compo.id).subscribe({next: (data) => {
					console.log("revert solver: ", data.solution);
					this.messageService.add({
						severity: "success",
						detail: `Movimentazione annullata con successo.`
					});
					this.loadData();
				}, error: (response: HttpErrorResponse) => {
						this.messageService.add({
							severity: "error",
							detail: `Annullamento non riuscito: errore ${response.status}.`
						});
					}
				});
			}

		});

	}

	getMovimentazioneDestinazioneString (compo: CompoMovimentazione) {
		if (compo.destinazione != null) {
			return compo.destinazione.codice;
		} else if (compo.pratica != null) {
			return this.scuoleByPratica[compo.pratica].pratica.cui;
		} else {
			return null;
		}
	}


	downloadDataDetailAsXlsx() {
		const sheet_name = "movimentazioni_materiali";
		const listing = [];
		for (let mov of this.filteredMovimentazioni) {
			for (let item of mov.materiali) {
				listing.push({
					movimentazione_codice: mov.id,
					movimentazione_tipo: mov.tipo,
					origine: mov.origine?.codice,
					destinazione: this.getMovimentazioneDestinazioneString(mov),
					nmu: item.info.nmu,
					qt: item.qt,
					listino: item.info.listino,
					valore: item.info.listino * item.qt
				});
			}
		}

		const wb = exportDataToXlsx(
			["movimentazione_codice", "movimentazione_tipo", "origine", "destinazione", "nmu", "qt", "listino", "valore"],
			listing, {}, sheet_name
		);

		const now = new Date();
		downloadXlsxWorkbook(wb, `${sheet_name}_${dateAsDDMMYYYY(now, "")}_${datetimeAsHHMMSS(now)}.xlsx`);
	}

	uploadDataFromFile () {
		const ref = this.dialogService.open(MovimentazioniCaricamentoDialogComponent,
		{
			header: "Allineamento magazzini da file",
			modal: true,
			closable: false,
			width: "75vw",
			data: {
				imprese: this.listingImprese,
				magazzini: this.listingMagazzini,
				materiali: this.listingMateriali
			}
		});

		ref.onClose.subscribe((data) => {
			console.log("allineamenti per operazione, magazzino, modello", data);
			if (data) {
				this.backendMagazzino.allineamentiUpload(data).subscribe({
				next: (data) => {
					const donekeys = Object.keys(data.done);
					const skipkeys = data.skipped;
					if (donekeys.length > 0) {
						this.messageService.add({severity: 'success', summary: '', detail: `Sono state caricate le operazioni ${donekeys.join(", ")}`, life: 5000, styleClass: "message_debug_wide"}, );
					}
					if (skipkeys.length > 0) {
						this.messageService.add({severity: 'warn', summary: '', detail: `Operazioni ${skipkeys.join(", ")} già caricate in precedenza.`, styleClass: "message_debug_wide", life: 5000});
					}
					this.loadData();
				},
				error: (e: HttpErrorResponse) => {
					console.warn(e);
					this.messageService.add({
						severity: 'error', summary: 'Errore nel caricamento dei dati',
						detail: `Errore ${e.status}: ${e.error?.error ?? e.message}`, sticky: true,
						styleClass: "message_debug_wide",
						closable: true
					});
				}
			})
			}

		});
	}

	downloadDataAsXlsx () {
		const sheet_name = "movimentazioni_lista";
		const wb = exportDataToXlsx(
			["id", "tipo", "mittente", "origine", "destinatario", "destinazione", "spedita", "consegnata"],
			this.filteredMovimentazioni.map((item) => {
				return {
					id: item.id,
					tipo: item.tipo,
					mittente: item.mittente?.ragioneSociale,
					destinatario: item.destinatario?.ragioneSociale,
					origine: item.origine?.codice,
					destinazione: this.getMovimentazioneDestinazioneString(item),
					spedita: item.spedito,
					consegnata: item.consegnato,
				}
			}), {}, sheet_name
		);

		const now = new Date();
		downloadXlsxWorkbook(wb, `${sheet_name}_${dateAsDDMMYYYY(now, "")}_${datetimeAsHHMMSS(now)}.xlsx`);
	}

	async getPraticaById (praticaid: number) {
		const results = [];
		const collectionRef = this.firestore.collection(this.environment.firebase.collection_pratiche).ref;
		const snapshot = await  collectionRef.where('id', '==', praticaid).get();
		snapshot.forEach((item) => {
			results.push(item.data());
		});

		if (results.length < 2) {
			return results[0] ?? null;
		} else {
			console.warn("MULTIPLE RESULTS FOR QUERY: ", results);
			return null;
		}
	}

	openPagePraticaMovimentazione (compo: CompoMovimentazione) {
		this.router.navigate(['/pratiche-bando2/fase-2/'], { queryParams: {
			pratica: this.scuoleByPratica[compo.pratica].pratica.cui
			}
		});
	}

	cancelInstallation (compo: CompoMovimentazione) {
		this.confirmationService.confirm({
			message: `annullare installazione pratica ${compo.pratica}?`,
			accept: () => {
				this.backendMagazzino.praticaConsegnaAnnulla(compo.pratica).subscribe((data) => {
					console.log("annullate ", data.listing);
					this.loadData();
				})
			}
		});
	}

	openInstallationForm (compo: CompoMovimentazione) {
		console.log("opening installation form for", compo);
		// opens the STANDARD INSTALLATION DIALOG
		this.getPraticaById(compo.pratica).then((pratica: PraticaFlowdy2_Firestore) => {
			// console.log("found pratica ", pratica);

			const ref = this.dialogService.open(DialogComunicaEsitoAppuntamentoFase2, {
				data: {
					pratica: pratica,
				},
				header: "Comunica l'esito dell'installazione del router per la pratica " + pratica.cui,
				width: "70%",
				height: "75%",
				baseZIndex: 10000,
				closable: true,
				draggable: false,
			});

			ref.onClose.subscribe((esitoInstallazione) => {
				if (esitoInstallazione && esitoInstallazione.success) {
					this.messageService.add({severity: 'success', summary: '', detail: 'Esito installazione router comunicata con successo!', life: 3000});
					this.loadData();
				}
			});


		})
	}
}

export interface CompoMovimentazione {
	id:				string;
	tipo:			TipoMovimentazione|string;
	pratica:		number;
	stato_pratica:	number|null;
	materiali:		{
		id:			string;
		info:		ModelloDispositivoApiDescriptor;
		qt:			number;
	}[];
	mittente:		Impresa;
	destinatario:   Impresa;
	origine: 		MagazzinoApiDescriptor;
	destinazione: 	MagazzinoApiDescriptor;
	spedito:		string; // YYYY-MM-DD
	consegnato:		string; // YYYY-MM-DD
	dataSpedito:	Date;
	dataConsegnato: Date;
	discrepanza: {
		id:			string;
		stato:		StatoDiscrepanza;
	},
	correttivo_per: string;
	consegna_scaduta: boolean;
	allowConfirmDelivery: boolean;
	allowFillInstallationForm: boolean;
	allowFixInconsistency: boolean; // must be either "admins" or both sender and receiver (i.e. it's internal)
	note: string;

}

export enum StatoFaseSpedizione {
	TRANSITO,
	ATTESA_SPEDIZIONE,
	CONSEGNATO
}

